import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { DashboardSectionHeader } from '@/shared/components/dashboard/DashboardSectionHeader';
import { dashboardSectionPanelSx } from '@/shared/styles/surfaces';
import { extractApiError } from '@/shared/lib/extractApiError';
import { formatBookingDate } from '@/shared/utils/bookingWhen';
import { useGuidePendingExtensions } from '../hooks/useTripExtensions';
import { ExtensionStatusCard } from './ExtensionStatusCard';

/** Guide dashboard: open extra-time requests across all of the guide's trips. */
export function GuideExtensionRequests() {
  const query = useGuidePendingExtensions();
  const items = query.data ?? [];

  // Keep the dashboard quiet when there is nothing to act on.
  if (query.isSuccess && items.length === 0) return null;

  return (
    <Paper elevation={0} sx={{ ...dashboardSectionPanelSx }}>
      <DashboardSectionHeader
        title="Extra-time requests"
        subtitle="Respond before the hold runs out — the time is reserved until then."
      />
      {query.isLoading && <Skeleton variant="rounded" height={96} />}
      {query.isError && <Alert severity="error">{extractApiError(query.error).message}</Alert>}
      <Stack spacing={1.5}>
        {items.map((ext) => {
          const booking = ext.booking;
          const subtitle = booking
            ? [
                booking.travelerName,
                booking.destinationLabel,
                booking.startAt && booking.endAt
                  ? formatBookingDate({ travelDate: booking.startAt, startAt: booking.startAt, endAt: booking.endAt })
                  : undefined,
                `${booking.travelerCount} traveler${booking.travelerCount === 1 ? '' : 's'}`,
              ]
                .filter(Boolean)
                .join(' · ')
            : undefined;
          return <ExtensionStatusCard key={ext.id} extension={ext} viewer="guide" subtitle={subtitle} />;
        })}
      </Stack>
    </Paper>
  );
}
